// JS
import '../../custom/js/index';
import '../../custom/js/components/accordion.js';
import '../../custom/js/components/main-service-line.js';

// Base SCSS
import '../../custom/scss/base.scss';
import '../../custom/scss/layout.scss';

// Components SCSS
import '../../custom/scss/components/breadcrumb/breadcrumb.scss';
import '../../custom/scss/components/hero/hero-main-service-line.scss';
import '../../custom/scss/components/home/cta-section.scss';
import '../../custom/scss/components/cta/cta.scss';
import '../../custom/scss/components/main-service-line/main-service-line.scss';
import '../../custom/scss/components/widget/panel-block.scss';
import '../../custom/scss/components/accordion/accordion.scss';
